import React, { useState, useEffect } from "react";
import Footer from "../../footer";
import AdminSidebar from "../sidebar";
import { getIdData, addData, updateData } from "../../../lib/booklist"
import { useNavigate, useParams } from 'react-router-dom';

export default function BookListEdit() {

  const [title, setTitle] = useState();
  const [author, setAuthor] = useState();
  const [isActive, setIsActive] = useState();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  let { slug } = useParams();


  async function GetData(id) {
    const bookData = await getIdData(slug);
    console.log("parameterData", bookData[0]);
    setData(bookData);
    setTitle(bookData[0].title);
    setAuthor(bookData[0].author);
    setIsActive(bookData[0].isActive);
  }

  const handleSubmit = async (e) => {
      e.preventDefault();

    if (slug === "Add") {
      console.log("Add");
      await addData({
        title: title,
        author: author,
        isActive: isActive
      });
    }
    else {
      console.log("Update");
      await updateData({
        id: slug,
        title: title,
        author: author,
        isActive: isActive
      });
    }

    navigate("/admin/admin-booklist");
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug !== "Add") {
      GetData(slug);
    }
  }, [slug])
  return (
            <div className="col-xl-12 col-md-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-2">
                  <div className="profile-heading p-2">
                    <h3>{slug === "Add" ? "Add Book" : "Update Book" }</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Title
                            </label>
                            <input
                              type="text"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              className="form-control"
                              placeholder="Enter Title"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">Author</label>
                            <input
                              type="text"
                              value={author}
                              onChange={(e) => setAuthor(e.target.value)}
                              className="form-control"
                              placeholder="Enter Author"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Is Active
                            </label>
                            <div className="form-check form-switch check-on">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isActive}
                                onChange={(e) => setIsActive(!isActive)}
                              />
                             </div>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            {slug === "Add" ? "Add Book" : "Update Book" }
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
  );
}
